export enum TransactionStatusEnum {
  Init = 0,
  Proccess = 1,
  Success = 2,
  Failed = 3,
  Refund = 4,
  Deleted = -2,
}

export enum TransactionTypeEnum {
  Normal = 0,
  User = 1,
  Partner = 2,
}
